import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { formPagePath } from '../../utilities/route'
import { TABLET, LAPTOP } from '../../utilities/breakpoints'

const NavProgressReports = ({
  activePage,
  surveyId,
  languageCode,
  useTranslate,
}) => {

  const to = formPagePath(languageCode, surveyId, 'finish', 'progress-reports');
  const toThemes = formPagePath(languageCode, surveyId, 'finish', 'progress-reports', 'themes');
  const toDrivers = formPagePath(languageCode, surveyId, 'finish', 'progress-reports', 'drivers');
  const toStatements = formPagePath(languageCode, surveyId, 'finish', 'progress-reports', 'statements');

  return (
    <NavContainer className="finish-page__intro__nav">
      <Link
        to={to}
        className={`nav-item btn ${activePage === "overview" ? "active" : ""}`}
      >
        {useTranslate("data_vault.overview")}
      </Link>
      <Link
        to={toThemes}
        className={`nav-item btn ${activePage === "themes" ? "active" : ""}`}
      >
        {useTranslate("data_vault.themes")}
      </Link>
      <Link
        to={toDrivers}
        className={`nav-item btn ${activePage === "drivers" ? "active" : ""}`}
      >
        {useTranslate("data_vault.drivers")}
      </Link>
      <Link
        to={toStatements}
        className={`nav-item btn ${activePage === "statements" ? "active" : ""}`}
      >
        {useTranslate("data_vault.statements")}
      </Link>
    </NavContainer>
  )
}

export default NavProgressReports;

const NavContainer = styled.div`
  background-color:#ffffff;
  border-radius: 10px;
  padding: 5px;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: stretch;
  
  .nav-item {
    color: black;
    background-color: #fff;
    border-radius: 10px;
    padding: 5px 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;

    &.active {
      background: #F58220;
      color: #fff;
    }

    &:hover:not(.active) {
      color: #F58220;
    }

    &:active,
    &:focus {
      outline: none;
      box-shadow: none;
    }
    
    @media${TABLET} {
      padding: 5px 20px;
      font-size: 16px;
    }
    
    @media${LAPTOP} {
      padding: 10px 26px;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/navigation/nav-progress-reports.js